<template>
  <div
    ref="helper"
    id="helper"
    class="need-help"
    @click="push2QA"
    >
    <img ref="buttonImg" :src="require('@/assets/image/qaq.png')"/>
  </div>
</template>

<script>

export default {
  props: [],
  data () {
    return {

    }
  },
  methods: {
    push2QA () {
      this.$router.push({
        path: '/qa'
      })
    },
    dom () {
      return this.$refs.helper
    },
    eventFire (e, node) {
      if (e.clientY === 0 && e.clientX === 0) {
        return
      }
      e.stopPropagation()
      e.preventDefault()
      this.$nextTick(() => {
        // console.log(`drag;x:${e.clientX};y:${e.clientY}`)
        node.style.left = `${e.clientX - 50}px`
        node.style.top = `${e.clientY - 50}px`
      })
    }
  },
  mounted () {
    let node = this.$refs.helper
    node.style.transition = 'none'
    node.addEventListener('drag', (e) => {
      this.eventFire(e, node)
    }, true)
    node.addEventListener('dragenter', (e) => {
      this.eventFire(e, node)
    }, true)
    node.addEventListener('dragover', (e) => {
      this.eventFire(e, node)
    }, true)
    node.addEventListener('drop', (e) => {
      this.eventFire(e, node)
    }, true)
  },
  created () {

  },
  computed: {

  },
  activated () {

  },
  deactivated () {

  }
}
</script>

<style lang="stylus" scoped>
.need-help
  position fixed
  right 0%
  bottom 2%
  height 100px
  width 100px
  font-size 0
  z-index 101
  img
    height 100%
    width 100%
</style>
